// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"d947d4b55c303c1a","931":"ed8097c4115966d7"}[chunkId] + ".css";
};